import { selectGridSelection } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.selector';
import { selectOrderPayPackagesGridActiveEditRow } from '@AMIEWEB/Order/Store/Order.selectors';
import { Skeleton } from '@mui/material';
import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';

export const LoadableCell = ({ renderComponent, params }) => {
  const OrderPayPackagesGridActiveEditRow = useSelector(selectOrderPayPackagesGridActiveEditRow);
  const { selectedData } = useSelector(selectGridSelection);
  const { promiseInProgress: loadingMarginInProgress } = usePromiseTracker({
    area: 'track-get-peopleSoft-calculated-values',
  });
  const { promiseInProgress: loadingMarginResetInProgress } = usePromiseTracker({
    area: 'track-get-order-packages-reset-values',
  });
  const loadingMarginCalculation =
    OrderPayPackagesGridActiveEditRow?.scenarioId === params?.row?.scenarioId && loadingMarginInProgress;
  const loadingMarginReset = selectedData.includes(params?.row?.scenarioId) && loadingMarginResetInProgress;

  return (
    <>
      {loadingMarginCalculation || loadingMarginReset ? (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      ) : (
        renderComponent
      )}
    </>
  );
};

export const renderLoadableCell = ({ renderComponent, params }) => {
  return <LoadableCell renderComponent={renderComponent} params={params} />;
};
